import { Box, Card, Typography } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";
import { AppUtils } from "../../../utils/appUtils";
import MessageBlock from "../../../pages/admin/components/message-block/MessageBlock";
import { NO_RECORDS_FOUND, REPORT_NOT_DRAWN } from "../../../utils/constants";

const ChartDataByAge = ({ chartDataByAge }) => {
  if (!chartDataByAge?.AGE_WISE_DATA) return null;

  const ageWiseData = chartDataByAge.AGE_WISE_DATA;
  const ageCategories = Object.keys(ageWiseData.MALE || {});

  // Map and filter out age groups where all values are 0
  const filteredData = ageCategories
    .map((age) => ({
      age,
      male: ageWiseData.MALE?.[age] ?? 0,
      female: ageWiseData.FEMALE?.[age] ?? 0,
      other: ageWiseData.OTHER?.[age] ?? 0,
    }))
    .filter((item) => item.male !== 0 || item.female !== 0 || item.other !== 0);

  const options = {
    series: [
      {
        name: "पुरुष",
        data: filteredData.map((item) => item.male)
      },
      {
        name: "महिला",
        data: filteredData.map((item) => item.female)
      },
      {
        name: "अन्य",
        data: filteredData.map((item) => item.other)
      },
    ],

    chart: { type: "bar", height: 350, stacked: true },

    stroke: { width: 1, colors: ["#fff"] },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${AppUtils.replaceWithNepaliDigit(val)} जना`,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${AppUtils.replaceWithNepaliDigit(val)} जना`,
      },
    },
    title: {
      text: "चालु आर्थिक वर्षमा आएका सेवाग्राहीहरुको उमेर अनुसारको वर्गिकरण",
      align: "center",
      style: { fontSize: "15px" },
    },
    plotOptions: { bar: { horizontal: false } },
    xaxis: {
      categories: filteredData.map((item) => AppUtils.replaceWithNepaliDigit(item.age)),
      title: { text: "उमेर" },
    },
    fill: { opacity: 1 },
    colors: ["#80c7fd", "#008FFB"],
    yaxis: {
      labels: { formatter: (val) => val },
      title: { text: "जम्मा संख्या" },
    },
    legend: { position: "top", horizontalAlign: "center" },
  };

  return (
    <Card mt={2}>
      {filteredData.length > 0 ? <Chart options={options} series={options.series} type="bar" height={350} /> : (
        <MessageBlock text={NO_RECORDS_FOUND} />
      )}
    </Card>
  );
};

export default ChartDataByAge;
